﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customQRCodeList from './tpl/customQRCodeList.html';
import View_CustomQRCodeListItem from './customQRCodeListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customQRCodeList',
    childViewContainer: '#customQRCodeList',
    childView: View_CustomQRCodeListItem,
    getTemplate: function () {
        return tpl_customQRCodeList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
